export default __webpack_public_path__ + "7561138.png";